import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import Account from "@/views/account/Account";
import RecentEditedAccResults from "@/views/account/RecentEditedAccResults";
import Login from "@/views/auth/Login.vue";
import Retention from "@/views/retention/Retention";
import RetentionLeadView from "@/views/retention/RetentionLeadView";
import RetentionReports from "@/views/retention/RetentionReports";
import Product from "@/views/Product";
import Notes from "@/views/product/Notes";
import CreditControl from "@/views/account/CreditControl";
import ProductList from "@/views/ProductList.vue";
import Lead from "@/views/Lead";
import Daily from "@/views/Daily";
import Demos from '@/views/Demos';
import Dashboard from "@/views/dashboard/Dashboard";
import NumberTransfers from "@/views/NumberTransfers";
import CreditNotes from "@/views/CreditNotes";
import TicketsList from "@/views/TicketsList";
import Ticket from "@/views/Ticket";
import NumberPoolAdmin from "@/views/admin/NumberPool";
import Search from "@/views/Search";
import Comms from '@/views/comms/Comms';
import Cpl from '@/views/marketing/Cpl';
import TelcoWorkflow from '@/views/telcoWorkflow/TelcoWorkflow';
import CreditControlDashboard from '@/views/creditControlDashboard/CreditControlDashboard';
import OnDashboard from '@/views/ledger/OnDashboard';

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/search/",
      name: "search",
      component: Search,
      meta: {
        isAuthenticated: true,
        gtm: 'Search'
      },
    },
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      meta: {
        isAuthenticated: true,
        gtm: 'Dashboard'
      },
    },
    {
      path: "/login/",
      name: "login",
      component: Login,
      meta: {
        isVisitor: true,
        gtm: 'Login'
      },
    },
    {
      path: "/accounts/",
      name: 'accounts',
      component: RecentEditedAccResults,
      meta: {
        isAuthenticated: true,
        gtm: 'Billing Accounts'
      },
    },
    {
      path: "/accounts/:id",
      name: "account",
      component: Account,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Billing Account'
      },
    },
    {
      path: "/retention/",
      name: "retention",
      component: Retention,
      meta: {
        isAuthenticated: true,
        gtm: 'Retention Leads'
      },
    },
    {
      path: "/retention/reports/",
      name: "retentionreports",
      component: RetentionReports,
      meta: {
        isAuthenticated: true,
        gtm: 'Retention Reports'
      },
    },
    {
      path: "/retention/:id",
      name: "retentionleadview",
      component: RetentionLeadView,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Retention Lead'
      },
    },
    {
      path: "/products/:id(\\d+)",
      name: "products",
      component: Product,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Product'
      },
    },
    {
      path: '/products/:id/histories',
      name: 'productsHistories',
      component: Notes,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Product Histories'
      },
    },
    {
      path: '/accounts/:id/credit-control',
      name: 'accountCreditControl',
      component: CreditControl,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Account Credit Control'
      },
    },
    {
      path: "/daily/",
      name: "daily",
      component: Daily,
      meta: {
        isAuthenticated: true,
        gtm: 'Daily Leads'
      },
    },
    {
      path: "/demos/",
      name: "demos",
      component: Demos,
      meta: {
        isAuthenticated: true,
        gtm: 'Demos'
      },
    },
    {
      path: "/leads/:id",
      name: "leads",
      component: Lead,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Lead'
      },
    },
    {
      path: "/products/",
      name: "productList",
      component: ProductList,
      meta: {
        isAuthenticated: true,
        gtm: 'Products'
      },
    },
    {
      path: "/number-transfers/",
      name: "numberTransfers",
      component: NumberTransfers,
      meta: {
        isAuthenticated: true,
        gtm: 'numberTransfers'
      },
    },
    {
      path: "/credit-notes/",
      name: "creditNotes",
      component: CreditNotes,
      meta: {
        isAuthenticated: true,
        gtm: 'creditNotes'
      },
    },
    {
      path: "/tickets/",
      name: "tickets",
      component: TicketsList,
      meta: {
        isAuthenticated: true,
        gtm: 'tickets'
      },
    },
    {
      path: "/tickets/:id",
      name: "tickets",
      component: Ticket,
      meta: {
        isAuthenticated: true,
        gtm: 'Single Ticket'
      },
    },
    {
      path: "/admin/number-pool/",
      name: "numberPoolAdmin",
      component: NumberPoolAdmin,
      meta: {
        isAuthenticated: true,
        gtm: 'numberPoolAdmin'
      },
    },
    {
      path: '/comms/',
      name: 'comms',
      component: Comms,
      meta: {
        isAuthenticated: true,
        gtm: 'comms'
      },
    },
    {
      path: '/marketing/cpl/',
      name: 'cpl',
      component: Cpl,
      meta: {
        isAuthenticated: true,
        gtm: 'cpl'
      },
    },
    {
      path: '/products/telco',
      name: 'telcoWorkflow',
      component: TelcoWorkflow,
      meta: {
        isAuthenticated: true,
        gtm: 'telcoWorkflow'
      },
    },
    {
      path: '/credit-control/',
      name: 'creditControlDashboard',
      component: CreditControlDashboard,
      meta: {
        isAuthenticated: true,
        gtm: 'creditControlDashboard'
      },
    },
    {
      path: '/ledger/on-dashboard',
      name: 'ledgerDashboard',
      component: OnDashboard,
      meta: {
        isAuthenticated: true,
        gtm: 'ledgerDashboard'
      },
    }
  ],
});

router.beforeEach((to, from, next) => {
  // redict all traffic to new CRM internal URL.
  const newUrl = `${process.env.VUE_APP_HOST_URL}${to.fullPath}`;
  window.location.replace(newUrl);

  /*   if (to.matched.some((record) => record.meta.isAuthenticated)) {
      if (!store.getters["auth/isLoggedIn"]) {
        let current = window.location.pathname;
        if (!/login/.test(current)) {
          localStorage.setItem("referrerURL", current);
        }
        next({
          name: "login",
        });
      } else {
        next();
      }
    } else if (to.matched.some((record) => record.meta.isVisitor)) {
      if (store.getters["auth/isLoggedIn"]) {
        next({
          name: "dashboard",
        });
      } else {
        next();
      }
    } else {
      next();
    } */
});

export default router;
